module.exports = __webpack_public_path__ + "img/mic_main.10240e48.svg";